import { configureStore } from '@reduxjs/toolkit'
import {languageReducer, contactusPopupReducer} from './rootReducer';

export default configureStore({
  reducer: {
    language: languageReducer.reducer,
    contactusPopup: contactusPopupReducer.reducer,
  },
})